@if (state.showSpinner) {
  <div class="spinner-wrap">
    <rt-spinner variant="small" />
  </div>
}

@if (!state.showSpinner) {
  <div>
    <rt-icon name="check" size="medium" />
    <rt-icon name="dot" size="small-x" />
  </div>
}
